import React from 'react';

import { H1, H2, P } from '../../components/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

const SecurityPolicy = () => (
  <div className='securityPolicy prl3-sm'>
    <H1 className='ta-sm-c mb10-sm'>
      <TranslatedCopy id='security.title' />
    </H1>
    <H2 className='mb5-sm'>
      <TranslatedCopy id='security.info.title' />
    </H2>
    <P className='mb12-sm'>
      <TranslatedCopy id='security.info.body' />
    </P>
    <H2 className='mb5-sm'>
      <TranslatedCopy id='security.registration.title' />
    </H2>
    <P className='mb12-sm'>
      <TranslatedCopy id='security.registration.body' />
    </P>
  </div>
);

export default SecurityPolicy;
